import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/site";

const CARDS = [
    { title: "Royal Rajasthan", image: IMAGES.rajasthanDoorway, span: "md:col-span-8 md:row-span-2 min-h-[340px] md:min-h-[560px]" },
    { title: "Himalayan Escapes", image: IMAGES.himalaya, span: "md:col-span-4 min-h-[260px]" },
    { title: "Kerala Tranquility", image: IMAGES.kerala, span: "md:col-span-4 min-h-[260px]" },
    { title: "Coastal Goa", image: IMAGES.goa, span: "md:col-span-6 min-h-[280px]" },
    { title: "Sacred Varanasi", image: IMAGES.varanasiGhats, span: "md:col-span-6 min-h-[280px]" },
];

export const Experiences = () => (
    <section className="bg-cream py-24 lg:py-32" data-testid="experiences-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
                <SectionHeading
                    eyebrow="Signature Experiences"
                    title="Five worlds, one incredible country"
                    description="From desert citadels to emerald backwaters — choose a mood, and we will craft the journey around it."
                />
                <Reveal delay={0.2}>
                    <Link
                        to="/packages"
                        data-testid="experiences-view-packages"
                        className="group inline-flex items-center gap-2 text-sm font-semibold text-navy transition-colors hover:text-brass-dark"
                    >
                        View all packages
                        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </Link>
                </Reveal>
            </div>

            <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-12">
                {CARDS.map((card, i) => (
                    <Reveal key={card.title} delay={i * 0.08} className={card.span}>
                        <Link
                            to={`/book?dest=${encodeURIComponent(card.title)}`}
                            data-testid={`experience-card-${i}`}
                            className="group relative flex h-full w-full items-end overflow-hidden rounded-2xl"
                        >
                            <img
                                src={card.image}
                                alt={card.title}
                                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/25 to-transparent transition-opacity duration-500 group-hover:opacity-90" />
                            <div className="relative z-10 flex w-full items-center justify-between p-7">
                                <h3 className="font-serif text-2xl font-semibold text-ivory">{card.title}</h3>
                                <span className="flex h-10 w-10 items-center justify-center rounded-full border border-brass/60 text-brass transition-all duration-300 group-hover:bg-brass group-hover:text-navy">
                                    <ArrowUpRight className="h-4 w-4" />
                                </span>
                            </div>
                        </Link>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
